"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../../common/Modal/Modal"));
var _APLabelWithText = _interopRequireDefault(require("../../../common/APLabelWithText"));
var _APIcon = _interopRequireDefault(require("../../../common/APIcon"));
var _dateHelper = require("../../../../helpers/dateHelper");
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _formTemplateHelper = require("../../../../helpers/formTemplateHelper");
require("./FiatWithdrawModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var fiatWithdrawModalClasses = (0, _cssClassesHelper.getBEMClasses)('fiat-withdraw-modal');
var FiatWithdrawModalComponent = function FiatWithdrawModalComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var template = props.template,
    payload = props.payload,
    TicketAmount = props.TicketAmount,
    fee = props.fee;
  var ProductSymbol = payload.ProductSymbol,
    ProductFullName = payload.ProductFullName;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: props.isOpen,
    title: /*#__PURE__*/_react["default"].createElement("div", {
      className: fiatWithdrawModalClasses('header-content')
    }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
      name: 'withdrawWithBorder',
      customClass: fiatWithdrawModalClasses('icon')
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: fiatWithdrawModalClasses('header-title')
    }, "".concat(t('Withdraw'), " ").concat(ProductSymbol, " ").concat(ProductFullName))),
    close: props.close,
    footer: {
      buttonText: t('Confirm'),
      buttonStyle: 'additive',
      onClick: function onClick() {
        return props.submitWithdraw(props.payload);
      }
    },
    customClass: fiatWithdrawModalClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: fiatWithdrawModalClasses('title')
  }, t('Confirmation')), /*#__PURE__*/_react["default"].createElement("div", {
    className: fiatWithdrawModalClasses()
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Amount to Withdraw'),
    text: "".concat(TicketAmount, " ").concat(ProductSymbol),
    customClass: fiatWithdrawModalClasses()
  }), (0, _formTemplateHelper.templateConfirmRenderer)(template, payload, fiatWithdrawModalClasses, {
    t: t
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Fee'),
    text: fee,
    customClass: fiatWithdrawModalClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Time'),
    text: (0, _dateHelper.formatDateTime)(new Date()),
    customClass: fiatWithdrawModalClasses()
  })));
};
FiatWithdrawModalComponent.propTypes = {
  payload: _propTypes["default"].object,
  close: _propTypes["default"].func.isRequired
};
FiatWithdrawModalComponent.defaultProps = {
  payload: {
    FullName: '',
    Amount: '',
    BankAccountName: '',
    BankAccountNumber: '',
    BankAddress: '',
    Comment: ''
  }
};
var _default = exports["default"] = FiatWithdrawModalComponent;